import React, { useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
  text: string;
  className?: string;
  maxWidth?: string | number;
  placement?: "top" | "right" | "bottom" | "left";
}

const TextWithTooltip: React.FC<Props> = ({
  text,
  className,
  maxWidth = "100%",
  placement = "top",
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const handleMouseEnter = () => {
    if (textRef.current) {
      const el = textRef.current;
      const overflow = el.scrollWidth > el.clientWidth;
      setIsOverflowing(overflow);
    }
  };

  const handleMouseLeave = () => {
    setIsOverflowing(false);
  };

  const content = (
    <span
      ref={textRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`d-inline-block text-truncate ${className || ""}`}
      style={{ maxWidth }}
    >
      {text || "-"}
    </span>
  );

  return isOverflowing ? (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={`tooltip-${text}`}>{text}</Tooltip>}
    >
      {content}
    </OverlayTrigger>
  ) : (
    content
  );
};

export default TextWithTooltip;
